import {LqbPricerLoanRequestLog} from "../../lqb_pricer_log/model/LqbPricerLoanRequestLog";
import {IHttpPromise, IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";

export class LqbPricerLogService {

    private $http: IHttpService;
    public static instance = ['$http', LqbPricerLogService];

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    public getCalculationLqbPricerLog = (logId: number): IHttpPromise<LqbPricerLoanRequestLog> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl(`api/calculations/execution/log/${logId}/lqb_pricer/log`)
        })
    }
}